<template>
  <div id="HoverCourseManagemenrList">
    <ul id="menu-hover-list">
      <!-- 1 -->
      <li
        @mouseover="onOver"
        id="dropdown1"
        @mouseleave="onLeave"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown-1"
          dropright
          no-caret
          ref="dropdown1"
          variant="none"
          size="sm"
          class="hover-menu-company"
        >
          <template v-slot:button-content class="hover-icon-main">
            <b-icon
              icon="building"
              aria-hidden="true"
              class="hover-icon"
            ></b-icon>
          </template>
          <div class="link-title hover-title">
            {{ profile.company.displayName }}
          </div>
          <b-dropdown-item
            v-for="(item, index) in userWorkAtCompanies"
            :key="index"
            :href="`/${item.company.url}`"
            class="hover-menu-item"
          >
            <strong class="m-0 p-0 d-block">
              {{ item.company.displayName }}
            </strong>
            <span class="small">{{ item.fullName }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- 2 -->
      <li
        @mouseover="onOver"
        id="dropdown_courseManage"
        @mouseleave="onLeave"
        v-access="{
          menu: 'course',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_courseManage"
          dropright
          no-caret
          ref="dropdown_courseManage"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content class="hover-icon-main">
            <b-icon-book-half class="mr-1 hover-icon"></b-icon-book-half>
          </template>
          <div class="link-title hover-title">คอร์สเรียน</div>

          <b-dropdown-item
            v-for="item in hoverlist['dropdown_courseManage']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            variant="none"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- Book management -->
       <li
        @mouseover="onOver"
        id="dropdown_bookManage"
        @mouseleave="onLeave"
        v-access="{
          menu: 'book-management',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_bookManage"
          dropright
          no-caret
          ref="dropdown_bookManage"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content class="hover-icon-main">
            <b-icon-book class="mr-1 hover-icon" />
          </template>
          <div class="link-title hover-title">หนังสือ</div>

          <b-dropdown-item
            v-for="item in hoverlist['dropdown_bookManage']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            variant="none"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- 3 -->
      <li
        @mouseover="onOver"
        id="dropdown_member"
        @mouseleave="onLeave"
        v-access="{
          menu: 'user',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_member"
          dropright
          no-caret
          ref="dropdown_member"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content hover-icon>
            <b-icon-people-fill class="mr-1"></b-icon-people-fill>
          </template>
          <div class="link-title menu_hide hover-title">ผู้เรียน</div>
          <b-dropdown-item
            v-for="item in hoverlist['dropdown_member']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- 4 -->
      <li
        @mouseover="onOver"
        id="dropdown_main_exam"
        @mouseleave="onLeave"
        v-access="{
          menu: 'exam',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_main_exam"
          dropright
          no-caret
          ref="dropdown_main_exam"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content>
            <b-icon-file-text-fill class="mr-1"></b-icon-file-text-fill>
          </template>
          <div class="link-title menu_hide hover-title">ข้อสอบ</div>
          <b-dropdown-item
            v-for="item in hoverlist['dropdown_main_exam']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- approve course complete -->
      <li
        @mouseover="onOver"
        id="dropdown_course_complete"
        @mouseleave="onLeave"
        v-access="{
          menu: 'courseComplete',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_course_complete"
          dropright
          no-caret
          ref="dropdown_course_complete"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content>
            <div>
              <i class="bi bi-clipboard-check-fill"></i>
            </div>
          </template>
          <div class="link-title menu_hide hover-title">อนุมัติการจบคอร์ส</div>
          <b-dropdown-item
            v-for="item in hoverlist['dropdown_course_complete']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- attendance -->
      <li
        @mouseover="onOver"
        id="dropdown_attendance"
        @mouseleave="onLeave"
        v-access="{
          menu: 'attendance',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_attendance"
          dropright
          no-caret
          ref="dropdown_attendance"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content>
            <div>
              <img
                src="@/assets/images/icon/icon_attendance.svg"
                alt="attendance"
                height="22px"
              />
            </div>
          </template>
          <div class="link-title menu_hide hover-title">การเข้าชั้นเรียน</div>
          <b-dropdown-item
            v-for="item in hoverlist['dropdown_attendance']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- purchase -->
      <li
        @mouseover="onOver"
        id="dropdown_purchase"
        @mouseleave="onLeave"
        v-access="{
          menu: 'purchase',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_purchase"
          dropright
          no-caret
          ref="dropdown_purchase"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content>
            <b-icon icon="cash" class="mr-1" />
          </template>
          <div class="link-title menu_hide hover-title">การชำระเงิน</div>
          <b-dropdown-item
            v-for="item in hoverlist['dropdown_purchase']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- 5 -->
      <li
        @mouseover="onOver"
        id="dropdown_analytics"
        @mouseleave="onLeave"
        v-access="{
          menu: 'analytics',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_analytics"
          dropright
          no-caret
          ref="dropdown_analytics"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content>
            <b-icon-bar-chart-line-fill
              class="mr-1"
            ></b-icon-bar-chart-line-fill>
          </template>
          <div class="link-title menu_hide hover-title">ข้อมูลเชิงลึก</div>
          <b-dropdown-item
            v-for="item in hoverlist['dropdown_analytics']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- ไอคอนรายงาน -->
      <li
        @mouseover="onOver"
        id="dropdown_report"
        @mouseleave="onLeave"
        v-access="{
          menu: 'report',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_report"
          dropright
          no-caret
          ref="dropdown_report"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content>
            <b-icon-clipboard class="mr-1"></b-icon-clipboard>
          </template>
          <div class="link-title menu_hide hover-title">รายงาน</div>
          <b-dropdown-item
            v-for="item in hoverlist['dropdown_report']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- 6 -->
      <li
        @mouseover="onOver"
        id="dropdown_discuss"
        @mouseleave="onLeave"
        v-access="{
          menu: 'discussion',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_discuss"
          dropright
          no-caret
          ref="dropdown_discuss"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content>
            <b-icon-chat-right-text-fill />
          </template>
          <div class="link-title menu_hide hover-title">กระดานถาม-ตอบ</div>
          <b-dropdown-item
            v-for="item in hoverlist['dropdown_discuss']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- 7 -->
      <li
        @mouseover="onOver"
        id="dropdown_live"
        @mouseleave="onLeave"
        v-access="{
          menu: 'live',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_live"
          dropright
          no-caret
          ref="dropdown_live"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content>
            <b-icon-camera-video-fill />
          </template>
          <div class="link-title menu_hide hover-title">Live</div>
          <b-dropdown-item
            v-for="item in hoverlist['dropdown_live']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- 8 -->
      <li
        @mouseover="onOver"
        id="dropdown_affiliate"
        @mouseleave="onLeave"
        v-access="{
          menu: 'affiliate',
        }"
        class="hover-menu"
      >
        <b-dropdown
          id="dropdown_affiliate"
          dropright
          no-caret
          ref="dropdown_affiliate"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content>
            <b-icon icon="link45deg"></b-icon>
          </template>
          <div class="link-title menu_hide hover-title">Affiliate Program</div>
          <b-dropdown-item
            v-for="item in hoverlist['dropdown_affiliate']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>

      <!-- 9 -->
      <li
        @mouseover="onOver"
        id="dropdown_ect"
        @mouseleave="onLeave"
        v-access="{
          menu: 'misc',
        }"
      >
        <b-dropdown
          id="dropdown_ect"
          dropright
          no-caret
          ref="dropdown_ect"
          variant="none"
          size="sm"
        >
          <template v-slot:button-content>
            <b-icon-display />
          </template>
          <p class="link-title menu_hide hover-title">อื่นๆ</p>
          <b-dropdown-item
            v-for="item in hoverlist['dropdown_ect']"
            :key="item.title"
            @click="onGoto(item.to.name)"
            class="hover-menu-item"
            :class="getCollapseListIsActive(item)"
          >
            {{ item.title }}
          </b-dropdown-item>
        </b-dropdown>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from "lodash";
import AuthMixin from "@/mixins/auth-mixin.js";
import CustomUserPermissionMixin from "@/mixins/custom-user-permission-mixin.js";
import { mapGetters } from "vuex";
import CompanySideBars from "./sidebars/CompanySidebarSwitch";
import { checkSubMenuAccess } from "../../services/accessControl";
import { getAdminProfiles } from "@/helpers/company-access";

export default {
  props: { company: Object, profile: Object },
  mixins: [AuthMixin, CustomUserPermissionMixin],
  data() {
    return {
      companyUrl: "",
      comId: this.$store.state.Company.companyInfo.id,
      memberId: JSON.parse(localStorage.getItem("user")).id,
      isActive: true,
      hover: false,
      position: "",
      index: "one",
      pointer: "",
      active: null,
      hoverlist: {
        dropdown_courseManage: [],
        dropdown_bookManage: [],
        dropdown_member: [],
        dropdown_main_exam: [],
        dropdown_course_complete: [],
        dropdown_attendance: [],
        dropdown_purchase: [],
        dropdown_analytics: [],
        dropdown_report: [],
        dropdown_discuss: [],
        dropdown_live: [],
        dropdown_affiliate: [],
        dropdown_ect: [],
      },
    };
  },
  computed: {
    ...mapGetters("Authentication", ["authUser"]),
    userWorkAtCompanies() {
      return getAdminProfiles(this.authUser);
    },
    Ac(hl) {
      return hl.to.name.includes(this.$route.name);
    },
    mainanalyticsListCssObj() {
      return {
        active: this.isActive,
      };
    },
  },
  created() {
    this.companyUrl = this.$route.params.company;
  },
  async mounted() {
    this.checkCourseMenuAccess();
    this.checkBookMenuAccess();
    this.checkMemberMenuAccess();
    this.checkExamMenuAccess();
    this.checkCourseCompleteMenuAccess();
    this.checkAttendanceMenuAccess()
    this.checkPurchaseMenuAccess();
    this.checkAnalyticsMenuAccess();
    this.checkReportMenuAccess();
    this.checkDiscussionMenuAccess();
    this.checkLiveMenuAccess();
    this.checkAffiliateMenuAccess();
    this.checkEtcMenuAccess();
  },
  methods: {
    ...CompanySideBars,
    checkCourseMenuAccess() {
      if (checkSubMenuAccess({ menu: "course-mgmt" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_courseManage"].push({
          title: "จัดการคอร์สเรียน",
          to: {
            name: "course.management.index",
          },
        });
      }
      if (
        checkSubMenuAccess({ menu: "course-tag-mgmt" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_courseManage"].push({
          title: "จัดการหมวดหมู่คอร์ส",
          to: {
            name: "tags.overview",
          },
        });
      }
      if (
        checkSubMenuAccess({ menu: "course-group-mgmt" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_courseManage"].push({
          title: "จัดการกลุ่มคอร์ส",
          to: {
            name: "course-group.management.index",
          },
        });
      }
      if (
        checkSubMenuAccess({ menu: "course-video-process-status" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_courseManage"].push({
          title: "สถานะการประมวลผลวิดิโอ",
          to: {
            name: "course.video-process-status",
          },
        });
      }
      if (
        checkSubMenuAccess({ menu: "course-additional-mgmt" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_courseManage"].push({
          title: "จัดการข้อมูลอื่นๆ",
          to: {
            name: "course.additional.management",
          },
        });
      }
    },
    checkBookMenuAccess() {
      if (checkSubMenuAccess({ menu: "book-management" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_bookManage"].push({
          title: "จัดการหนังสือ",
          to: {
            name: "book.management.index",
          },
        });
      }
      if (checkSubMenuAccess({ menu: "book-delivery" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_bookManage"].push({
          title: "การจัดส่งหนังสือ",
          to: {
            name: "book.delivery",
          },
        });
      }
      if (checkSubMenuAccess({ menu: "book-pickup" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_bookManage"].push({
          title: "การรับหนังสือที่สถาบัน",
          to: {
            name: "book.pickup",
          },
        });
      }
      if (checkSubMenuAccess({ menu: "book-delivery-purchase-report" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_bookManage"].push({
          title: "รายงานการซื้อที่ต้องรับ/ส่งหนังสือ",
          to: {
            name: "book.book-delivery-purchase-report",
          },
        });
      }
    },
    async checkMemberMenuAccess() {
      if (checkSubMenuAccess({ menu: "user-mgmt" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_member"].push({
          title: "จัดการผู้เรียน",
          to: {
            name: "member.index",
          },
        });
      }
      if (checkSubMenuAccess({ menu: "user-mgmt" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_member"].push({
          title: "จัดการผู้สอน",
          to: {
            name: "instructor.index",
          },
        });
      }
      if (
        checkSubMenuAccess({ menu: "user-group-mgmt" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_member"].push({
          title: "จัดการกลุ่มผู้เรียน",
          to: {
            name: "group.index",
          },
        });
      }
      if (checkSubMenuAccess({ menu: "enroll-mgmt" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_member"].push({
          title: "ลงทะเบียนเรียน",
          to: { name: "course.enroll.index" },
        });
      }
      if (checkSubMenuAccess({ menu: "admin-mgmt" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_member"].push({
          title: "จัดการผู้ใช้งาน",
          to: {
            name: [1000001, 1000002, 1000003].includes(parseInt(this.comId)) ? "members.wannasorn-role" : "members.role",
          },
        });
      }
      if (checkSubMenuAccess({ menu: "abnormal-usage-log" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_member"].push({
          title: "ตรวจสอบการเรียนผิดปกติ",
          to: {
            name: "members.abnormal-usage",
          },
        });
      }
      if (checkSubMenuAccess({ menu: "member-identity-verification" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_member"].push({
          title: "ยืนยันตัวตนสมาชิก",
          to: {
            name: "member.identity-verification",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "face-verify-overview" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_member"].push({
          title: "คำขอลงทะเบียนใบหน้า",
          to: {
            name: "face.verify.overview",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "member-face-registration-verification" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_member"].push({
          title: "ตรวจสอบใบหน้าลงทะเบียน",
          to: {
            name: "face.verify.overview2",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "member-face-learning-verification" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_member"].push({
          title: "การตรวจสอบใบหน้า",
          to: {
            name: "members.face-verification.index",
          },
        });
      }
    },
    checkExamMenuAccess() {
      if (checkSubMenuAccess({ menu: "exam-mgmt" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_main_exam"].push({
          title: "จัดการข้อสอบ",
          to: {
            name: "exam.build",
          },
          iconClass: "fas fa-book",
        });
      }
      if (
        checkSubMenuAccess({ menu: "exam-overview" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_main_exam"].push({
          title: "สรุปภาพรวมข้อสอบ",
          to: {
            name: "analytics.exam.overview",
          },
          iconClass: "fas fa-book",
        });
      }
      if (
        checkSubMenuAccess({ menu: "exam-answersheet" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_main_exam"].push({
          title: "กระดาษคำตอบ",
          to: {
            name: "analytics-answer-sheet-list",
          },
          iconClass: "fas fa-book",
        });
      }
      if (checkSubMenuAccess({ menu: "exam-upload" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_main_exam"].push({
          title: "อัปโหลดข้อสอบ",
          to: {
            name: "company.exam-management.upload",
          },
          meta: {
            module: "exam-management",
          },
          iconClass: "fas fa-book",
        });
      }
    },
    checkCourseCompleteMenuAccess() {
      if (
        checkSubMenuAccess(
          { menu: "course-complete-approval" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_course_complete"].push({
          title: "อนุมัติการจบคอร์ส",
          to: { name: "course.complete.list" },
        });
      }
    },
    checkAttendanceMenuAccess() {
      if (
        checkSubMenuAccess( 
          { menu: "attendance-summary" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_attendance"].push({
          title: "สรุปการเข้าชั้นเรียน",
          to: { name: "attendance.overview" },
        });
      }
      if (
        checkSubMenuAccess(
          { menu: "member-attendance-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_attendance"].push({
          title: "รายงานการเข้าเรียนรายบุคคล",
          to: { name: "members.attendance.report" },
        });
      }
      this.hoverlist["dropdown_attendance"].push({
        title: "จัดการคะแนนสอบ",
        to: { name: "exam.attendance" },
      });
    },
    checkPurchaseMenuAccess() {
      if (
        checkSubMenuAccess({ menu: "promotion-mgmt" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_purchase"].push({
          title: "จัดการโปรโมชั่น",
          to: {
            name: "purchase.course.promotion.list",
          },
        });
      }
      if (
        checkSubMenuAccess(
          { menu: "transfer-monet-list" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_purchase"].push({
          title: "รายการแจ้งโอนเงิน",
          to: {
            name: "purchase.course-transfer-money-list",
          },
        });
      }
      if (checkSubMenuAccess({ menu: "coupon-mgmt" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_purchase"].push({
          title: "จัดการคูปอง",
          to: {
            name: "purchase.course.coupon.list",
          },
        });
      }
      if (
        checkSubMenuAccess({ menu: "company-course-extend-price" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_purchase"].push({
          title: "ราคาชั่วโมงเรียนและวันเรียน",
          to: {
            name: "purchase.company.course.extend.price",
          },
        });
      }
      if (
        checkSubMenuAccess({ menu: "course-order-list" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_purchase"].push({
          title: "รายการสั่งซื้อคอร์สเรียน",
          to: {
            name: "purchase.course.order.list",
          },
        });
      }
      if (
        checkSubMenuAccess({ menu: "cash-register" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_purchase"].push({
          title: "ลงทะเบียนจ่ายเงินสด",
          to: {
            name: "purchase.register.cash",
          },
        });
      }
    },
    async checkAnalyticsMenuAccess() {
      if (
        checkSubMenuAccess({ menu: "user-analytics" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_analytics"].push({
          title: "ภาพรวมผู้เรียน",
          to: {
            name: "analytics.user.overview",
          },
        });
      }
      if (
        checkSubMenuAccess({ menu: "course-analytics" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_analytics"].push({
          title: "ภาพรวมคอร์ส",
          to: {
            name: "analytics.course.overview",
          },
        });
      }
      if (
        checkSubMenuAccess(
          { menu: "certificate-overview" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_analytics"].push({
          title: "ภาพรวมประกาศนียบัตร",
          to: {
            name: "analytics.certificate.overview",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "revenue-analytics" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_analytics"].push({
          title: "ภาพรวมรายได้",
          to: {
            name: "analytics.revenue.overview",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "tfac-overview" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_analytics"].push({
          title: "สรุปภาพรวมสภาบัญชี",
          to: {
            name: "analytics.tfac.overview",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "nyc-overview" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_analytics"].push({
          title: "สรุปภาพรวม NYC",
          to: {
            name: "analytics.tfac.overview",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "export-learning-history-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_analytics"].push({
          title: "รายงานการเข้าเรียน",
          to: {
            name: "export.data",
          },
        });
      }
    },
    async checkReportMenuAccess() {
      if (
        await checkSubMenuAccess(
          { menu: "tfac-purchase-summary-by-course-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานสรุปการขายรายหลักสูตร",
          to: {
            name: "report.tfac.purchasesummarybycoursereport",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "tfac-revenue-summary-by-course-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานการรับรู้รายได้",
          to: {
            name: "report.tfac.report",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "tfac-enroll-summary-by-course-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานสรุปจำนวนผู้สมัครเรียนแยกตามหลักสูตร",
          to: {
            name: "report.tfac.enrollsummarybycoursereport",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "trial-course-history-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานการทดลองเรียน",
          to: {
            name: "report.trial-course-enrollment-report",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "student-count-by-school-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานสรุปจำนวนผู้เรียนแยกตามโรงเรียน",
          to: {
            name: "report.student-count-by-school-report",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "student-course-summary-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานสรุปจำนวนคอร์สแยกตามผู้เรียน",
          to: {
            name: "report.student-course-summary-report",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "student-info-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานข้อมูลนักเรียน",
          to: {
            name: "report.student-info-report",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "learning-history-summary-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานสรุปประวัติการเรียน",
          to: {
            name: "report.learning-history-summary-report",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "tfac-individual-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานข้อมูลผู้เรียนรายบุคคล",
          to: {
            name: "report.tfac.individualstudentfile",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "tfac-completed-enoll-by-date-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานการจบคอร์สและสอบผ่าน",
          to: {
            name: "report.tfac.completedEnrollByDateReport",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "thaire-completed-courses-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานการจบคอร์สและสอบผ่าน",
          to: {
            name: "report.thaire.completedCoursesReport",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "learning-history-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "ประวัติการเข้าเรียน",
          to: {
            name: "report.learning-history-report",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "exam-detailed-result-report" },
          this.getCurrentUser()
        )
      ) {
        this.collapseList.push({
          title: "ประวัติการเข้าเรียน",
          to: {
            name: "report.exam-detailed-result-report",
          },
        });
      }
      if (
        await checkSubMenuAccess(
          { menu: "course-sales-history-report" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_report"].push({
          title: "รายงานการขายหลักสูตร",
          to: {
            name: "report.course-sales-history-report",
          },
        });
      }
    },
    checkDiscussionMenuAccess() {
      if (
        checkSubMenuAccess({ menu: "discussion-mgmt" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_discuss"].push({
          title: "สรุปภาพรวมคำถาม",
          to: {
            name: "analytics.discuss",
          },
        });
      }
    },
    checkLiveMenuAccess() {
      if (checkSubMenuAccess({ menu: "live-mgmt" }, this.getCurrentUser())) {
        this.hoverlist["dropdown_live"].push({
          title: "จัดการ Live",
          to: {
            name: "live.index",
          },
        });
      }
    },
    checkAffiliateMenuAccess() {
      if (
        checkSubMenuAccess(
          { menu: "affiliate-link-mgmt" },
          this.getCurrentUser()
        )
      ) {
        this.hoverlist["dropdown_affiliate"].push({
          title: "Affiliate Links",
          to: {
            name: "affiliate.link",
          },
        });
      }
    },
    checkEtcMenuAccess() {
      if (
        checkSubMenuAccess({ menu: "resource-usage" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_ect"].push({
          title: "ทรัพยากรในระบบ",
          to: {
            name: "resource.monitoring.overview",
          },
        });
      }
      if (
        checkSubMenuAccess({ menu: "carousel-mgmt" }, this.getCurrentUser())
      ) {
        this.hoverlist["dropdown_ect"].push({
          title: "จัดการรูปภาพแบนเนอร์",
          to: {
            name: "carousels",
          },
        });
      }
    },
    checkAuthorizationRoles(roles = []) {
      const companyId = this.$store.state.Company.companyInfo.id;
      const userRoles = this.$store.state.Authentication.authUser.roles
        .filter((el) => el.companyId === companyId)
        .map((el) => el.roleName);
      for (let role of roles) {
        if (userRoles.includes(role)) return true;
      }
      return false;
    },
    onGoto(e) {
      this.$router.push({ name: e });
      this.active = e;
      this.checkActiveRoute();
    },
    onOver(e) {
      let value = e.target.id;
      this.pointer = value;
      this.$refs[value].visible = true;
    },
    onLeave(e) {
      let value = e.target.id;
      this.$refs[value].visible = false;
    },
    checkActiveRoute() {
      const useModuleMetaMatcher = !!this.$route.meta.module;
      this.isActive = _.includes(
        _.map(this.hoverlist, (ech) => {
          if (!!ech.meta && !!ech.meta.module) {
            return ech.meta.module;
          }
          return ech.to.name;
        }),
        useModuleMetaMatcher ? this.$route.meta.module : this.$route.name
      );
    },
    getCollapseListIsActive(eachSidebarRoute) {
      const useModuleMetaMatcher = !!this.$route.meta.module;
      if (useModuleMetaMatcher) {
        return {
          active:
            !!eachSidebarRoute.meta &&
            !!eachSidebarRoute.meta.module &&
            this.$route.meta.module === eachSidebarRoute.meta.module,
        };
      }
      return {
        active: this.$route.name === eachSidebarRoute.to.name,
      };
    },
  },
};
</script>

<style lang="scss">
.hover-menu {
  margin: 9px;
  padding: 9px 7px !important;
  font-size: 12px;
  border: none !important;
  color: #bbbbbb;
}

.dropdown-menu {
  max-height: 500px;
  overflow-y: auto;
}

.dropdown > button {
  border: none !important;
}
.hover-menu .b-icon {
  color: #495464;
}
.hover-title {
  color: #ffffff;
  background-color: #071a36;
  width: 90%;
  margin: 0 auto;
  padding: 8px 15px;
  border-radius: 3px;
  font-size: 12px;
  text-align: left;
}

.hover-menu-item .dropdown-item.active,
.dropdown-item:active {
  background-color: #e8e8e8 !important;
  color: #343434 !important;
}

.hover-menu-item .dropdown-item.hover,
.dropdown-item:hover {
  background-color: #e8e8e8 !important;
  color: #343434 !important;
}

li.hover-menu-item {
  border-radius: 0px !important;
  font-size: 13px;
  text-align: left !important;
  margin: 0px !important;
  padding: 4px 0 !important;
}

ul.hover-menu-item {
  padding: 10px !important;
}

.hover_menu_click {
  background-color: #bbbfca;
  color: #ffffff;
}

#menu-hover-list li.active a {
  color: #f4f4f2;
  background: #bbbfca;
  padding: 10px 20px;
}
</style>
